<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="container-fluid w-100">
        <navbar :title="$t('menu.dispatches')"/>
        <div>
            <dispatch-search @search="fetchItems" class="my-2"/>
        </div>

        <div class="col-12 text-end my-2">
            <button
                class="btn btn-success form-button"
                @click="addNew"
            >
                {{ $t('common.add_new') }}
            </button>
        </div>
        <div v-if="results.length > 0" class="my-1 px-1">
            <dispatch-list :items="results" @rowClick="showDispatch"/>
        </div>
        <base-modal v-if="showEditor" hide-header hide-footer size="xl">
            <dispatch-editor v-if="dispatchItem" :item="dispatchItem" @close="closeEditor" @dispatchAdded="updateResults"/>
        </base-modal>
        <base-modal v-if="showDetails && dispatchItem" hide-footer hide-header size="lg">
            <dispatch-details :item="dispatchItem" @close="closeDetails"/>
        </base-modal>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import DispatchEditor from "@/components/dispatch/DispatchEditor";
import DispatchSearch from "@/components/dispatch/DispatchSearch";
import DispatchList from "@/components/dispatch/DispatchList";
import DispatchDetails from "@/components/dispatch/DispatchDetails";
import BaseModal from "@/components/BaseModal";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'Dispatch',
    components: {Navbar, BaseModal, DispatchDetails, DispatchList, DispatchSearch, DispatchEditor },
    mixins: [timeUtils, restApi],
    data: function () {
        return {
            loading: 0,
            dispatchItem: null,
            showEditor: false,
            showDetails: false,
            lastSearchParams: null,
            results: []
        }
    },
    methods: {
        addNew() {
            this.dispatchItem = {
                id: -1,
                description: '',
                work_order: null,
                created: null,
                deadline: null,
                completed: null,
                created_by: null,
                created_by_company: null,
                persons: [],
                contractors: [],
            }
            this.showEditor = true
        },

        closeEditor() {
            this.showEditor = false
            this.$nextTick(() => this.dispatchItem = null)
        },

        showDispatch(item) {
            this.dispatchItem = item
            this.showDetails = true
        },

        closeDetails() {
            this.showDetails = false
            this.$nextTick(() => this.dispatchItem = null)
        },

        updateResults() {
            this.closeEditor()
            this.fetchItems(this.lastSearchParams)
        },

        fetchItems(searchParams) {
            this.loading++
            this.results = []
            this.lastSearchParams = searchParams
            this.restFetchParams(this.dispatchUrl, searchParams, this.handleResults)
        },

        handleResults(response) {
            this.loading--
            if (response && response.data) {
                this.results = response.data
            }
        }


    }
}
</script>
